import axiosInstance from '../../axios-config';

const testResultsApi = '/api/patients/{0}/labresults/published';
const newTestResultCountApi = '/api/patients/{0}/labresults/NotReviewedCount';
const testResultDetailsApi = '/api/patients/{0}/labresults/{1}';
const testResultPdfApi = '/api/patients/{0}/labresults/published/{1}/pdf';


export const getTestResults = (patientId) => (
  axiosInstance.get(testResultsApi.replace('{0}', patientId))
);

export const getNewTestResultsCount = (patientId) => (
  axiosInstance.get(newTestResultCountApi.replace('{0}', patientId))
);

export const getTestResultDetails = (patientId, labResultId) => (
  axiosInstance.get(testResultDetailsApi
    .replace('{0}', patientId)
    .replace('{1}', labResultId))
);

export const getTestResultPdf = (patientId, labResultId) => (
  axiosInstance.post(testResultPdfApi
    .replace('{0}', patientId)
    .replace('{1}', labResultId),
  null,
  {
    responseType: 'arraybuffer',
  })
);

export const getTestResultContentUrl = (patientId, labResultId) => (
  axiosInstance.defaults.baseURL +
  testResultPdfApi
    .replace('{0}', patientId)
    .replace('{1}', labResultId)
);

